import { all, call, fork, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { MyCourseActionTypes } from './types'
import { IUserCourse } from '../interface'
import {getMyCourse} from './selectors'
import { fetchError, fetchSuccess, selectCourse, courseSelected, addSuccess, addError, editSuccess, editError, askTrainerSuccess, askTrainerError } from './actions'
import { GeneralUtil } from '../../utils/generalUtil';
import { UserCourseUtil } from '../../utils/dataUtil';
import { Table } from '../interface';

const generalUtil: GeneralUtil = new GeneralUtil();
const myCourseUtil: UserCourseUtil = new UserCourseUtil();

const getMyCoursesAPI = async (searchParams: any) => {
  searchParams.table = Table.UserCourse;
  return await generalUtil.GetList(searchParams);
}

const getMyCourseByIdAPI = async (id: string) => {
  //return await generalUtil.Read(id, Table.UserCourse);
  let mycourse = await generalUtil.Read(id, Table.UserCourse);
  if (mycourse.doc && mycourse.doc.concentrationId){
     let concentrationResult = await generalUtil.Read(mycourse.doc.concentrationId, Table.Concentration);
     if (concentrationResult.isSuccess){
        mycourse.doc.concentrationPictures = concentrationResult.doc;
     }
  }
  return mycourse;
}

const updateMyCourseAPI = async(keyValues:any) => {
  keyValues.table = Table.UserCourse;
  return await generalUtil.Update(keyValues);
}

const addMyCourseAPI = async(doc: IUserCourse) => {
  doc.table = Table.UserCourse;
  return await myCourseUtil.CreateMyCourse(doc); // Special logic to handle create new course
}

const sendAskTrainerEmail = async(doc:any) => {
  return await myCourseUtil.AskTrainer(doc);
}


function* handleFetch(action: any) {
  try {
    const res = yield call(getMyCoursesAPI, action.payload);
    if (res.isSuccess) {
      yield put(fetchSuccess(res))
    } else {
      
      yield put(fetchError(res.errors))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(fetchError(err.stack))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
  
}

function* handleSelect(action: ReturnType<typeof selectCourse>) {
  try {
    const company:IUserCourse[] = yield select(getMyCourse);
    const detail: IUserCourse |undefined =  company.find(f=>f.id === action.payload); //yield call(callApi, 'get', API_ENDPOINT, `/heroStats/${action.payload}`)
    //const submissionYear = detail === undefined ? [] : detail.roles ; //yield call(callApi, 'get', API_ENDPOINT, `/heroStats/${action.payload}/roles`)

    if (detail === undefined) {
      
      const res = yield call(getMyCourseByIdAPI, action.payload);
      if (res.isSuccess) {
        yield put(fetchSuccess({...res , doc:[res.doc] ,totalDoc:1 , offset:0 }))
      } else {
        
        yield put(fetchError(res.error))
      }
      
    } else {
      yield put(courseSelected( detail))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(fetchError(err.stack))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* handleAdd(action: any) {
  try {
    // Must pass in ID in keyValues
    action.payload.table = Table.UserCourse;
    const res = yield call(addMyCourseAPI, action.payload);
    if (res.isSuccess) {
      yield put(addSuccess(res.doc))
    } else {
      yield put(addError(res.errors))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(addError(err.stack))
    } else {
      yield put(addError('An unknown error occured.'))
    }
  }
}
function* handleUpdate(action:any) {
  try {
    // Must pass in ID in keyValues
    action.payload.table = Table.UserCourse;
    const res = yield call(updateMyCourseAPI, action.payload);
    if (res.isSuccess) {
      yield put(editSuccess(res.doc))
    } else {
      yield put(editError(res.errors))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(editError(err.stack))
    } else {
      yield put(editError('An unknown error occured.'))
    }
  }
}

function* handleAskTrainer(doc:any) {
  try {
    // Must pass in ID in keyValues
    const res = yield call(sendAskTrainerEmail, doc.payload);
    if (res.isSuccess) {
      yield put(askTrainerSuccess(doc.payload))
    } else {
      yield put(askTrainerError(res.error))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(askTrainerError(err.stack))
    } else {
      yield put(askTrainerError('An unknown error occured.'))
    }
  }
}

function* watchFetchRequest() {
  yield takeEvery(MyCourseActionTypes.FETCH_REQUEST, handleFetch)
}
function* watchSelectMyCourse() {
  yield takeLatest(MyCourseActionTypes.SELECT, handleSelect)
}
function* watchAddRequest() {
  yield takeEvery(MyCourseActionTypes.ADD, handleAdd)
}
function* watchUpdateRequest() {
  yield takeEvery(MyCourseActionTypes.EDIT, handleUpdate)
}

function* watchAskTrainerRequest() {
  yield takeEvery(MyCourseActionTypes.ASKTRAINER, handleAskTrainer)
}

function* MyCourseSaga() {
  //console.log("Started CourseSaga");
  yield all([
    fork(watchFetchRequest), 
    fork(watchAddRequest),
    fork(watchUpdateRequest),
    fork(watchSelectMyCourse), 
    fork(watchAskTrainerRequest)
  ]);
}

export default MyCourseSaga
